import { message, Modal } from "antd";
import { IAddCallback, api } from "./index";
import { lang } from "../context";
import { folderTypeEnum } from "../config/permissions.config";
import events from "../context/events";
import { ActionFnEnum, FileType } from "../types";

const Remove: IAddCallback = (props, isAllow, isTeam?: boolean) => {
  const { data, reload, gname, setData } = props;
  let folderArr = [...data];
  const batchDeleteDtoList = [...data].map((item) => {
    return {
      deleteType: isTeam ? folderTypeEnum.SHARE : folderTypeEnum.MY,
      targetId: item.id,
      targetType: typeof item.page_type !== "undefined" ? 1 : 4
    };
  });
  return [
    {
      children: lang("common.delete"),
      callbackOrModal: () => {
        Modal.confirm({
          title: `是否确认批量删除？`,
          content: gname ? "删除后不可在回收站恢复，请谨慎操作。" : "删除的文件可在回收站找回",
          cancelText: lang("common.cancel"),
          okText: lang("common.confirm"),
          onOk: () => {
            api.batch
              .remove(batchDeleteDtoList, gname ? 0 : 1)
              .then((data) => {
                if (data) {
                  events.emit("list.check");
                  message.success(lang("common.success"));
                  //   props.reload();

                  let folderIds: any[] = [];
                  let pageIds: any[] = [];
                  for (let item of batchDeleteDtoList) {
                    if (item.targetType === FileType.Folder) {
                      folderIds.push(item.targetId);
                    } else {
                      pageIds.push(item.targetId);
                    }
                  }
                  setData({
                    type: ActionFnEnum.BATCHREMOVE,
                    pids: pageIds,
                    cids: folderIds
                  } as any);
                  events.emit("batchDeleteFolderById", folderIds);
                } else {
                  message.error(lang("common.error"));
                }
              })
              .catch((err) => {
                message.error(lang("common.fail"));
              });
          }
        });
      },
      isAllow,
      type: "delete"
    }
  ];
};
export default Remove;
